import { RouterModule, Routes } from '@angular/router';

import { InspectionResolver } from '../../utils/inspection.resolver';
import { NewPointPageComponent } from '../pages/new.component';
import { NgModule } from '@angular/core';
import { PointDetailPageComponent } from '../pages/detail.component';
import { SynchronizationResolver } from '../../utils/syncronization.resolver';
import { PermissionGuard } from '../../utils/permission.guard';
import { environment } from '../../../environments/environment';

const appRoute = environment.applicationRoute;

const routes: Routes = [
  {
    path: '',
    resolve: { synchronizeData: SynchronizationResolver, inspection: InspectionResolver },
    children: [
      { path: '', redirectTo: appRoute + '/inspections', pathMatch: 'full' },
      { path: appRoute + '/inspections/:inspectionId/points/:pointId', component: PointDetailPageComponent },
      { path: appRoute + '/inspections/:inspectionId/sections/:sectionId/points/new', component: NewPointPageComponent },
      {
        path: appRoute + '/inspections/:inspectionId/sections/:sectionId/folders/:folderId/points/new',
        component: NewPointPageComponent
      }
    ]
  },
  {
    path: '',
    resolve: { inspection: InspectionResolver },
    children: [
      {
        path: appRoute + '/templates/:inspectionId/points/:pointId',
        component: PointDetailPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: appRoute + '/templates/:inspectionId/sections/:sectionId/points/new',
        component: NewPointPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: appRoute + '/templates/:inspectionId/sections/:sectionId/folders/:folderId/points/new',
        component: NewPointPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PointRoutingModule {}
export const routedComponents = [PointDetailPageComponent];
